/**
 * Studio 嵌入 Opinion/Marketing 页面时，筛选器会以 `{gameId|path}__{filterInstanceId}` 作为
 * sessionStorage key 的命名空间（见 opinion FilterCommon/utils/storage 的 getGameInfoKey）。
 *
 * 该工具按 filterInstanceId 精确扫描并清除 Studio 注入的筛选缓存：
 * - 仅匹配带 `__{filterInstanceId}` 标记的 key，绝不误删独立 Opinion/Marketing 路由的缓存；
 * - 仅清理 sessionStorage（筛选缓存本就只写 session），不动 localStorage；
 * - 不依赖 gameId，避免离开/进入时 gameId 未就绪导致漏清。
 *
 * 由各 Studio 路由组件在进入(mount) / 离开(unmount) 时调用：
 * - Tab 切换不触发路由 unmount → 各 Tab 共用同一 key → 继承筛选值；
 * - 离开 / 刷新触发清理 → 重新进入不继承。
 */
export function clearStudioFilterStorageByInstance(filterInstanceId: string): void {
  if (!filterInstanceId) {
    return;
  }
  const marker = `__${filterInstanceId}`;
  try {
    const keysToRemove: string[] = [];
    for (let i = 0; i < sessionStorage.length; i += 1) {
      const key = sessionStorage.key(i);
      if (key && key.includes(marker)) {
        keysToRemove.push(key);
      }
    }
    keysToRemove.forEach((key) => {
      sessionStorage.removeItem(key);
    });
  } catch {
    // ignore: 隐私模式 / 存储不可用时静默
  }
}
